import React from 'react';

import { make as SectionHeading } from '../../../../ui/components/SectionHeading.mjs';
import { make as ServicesCardCmp } from '../../../../ui/components/ServicesCardCmp.mjs';
import {
  CommonImage,
} from '../../../../shared/types/CommonVM';
import { HomeCityService } from '../../domain/entities/HomeContentEntity';

import styles from '../styles/ServicesSection.module.scss';

interface ServicesSectionCmpProps {
  services_cards_data: HomeCityService[];
  wave_icon: CommonImage;
  title: string;
}

function ServicesSectionCmp({
  services_cards_data,
  wave_icon,
  title,
}: ServicesSectionCmpProps): React.ReactElement {
  const cardsClassName =
    services_cards_data.length === 1
      ? styles['single-service-card-wrapper']
      : styles['services-cards-wrapper'];

  return (
    <div className={styles['our-services-section']}>
      <SectionHeading title={title} wave_icon={wave_icon} />
      <div className={styles['our-services-section-container']}>
        <div className={cardsClassName}>
          {services_cards_data.map((service_card, index) => (
            <ServicesCardCmp key={index} content={service_card} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ServicesSectionCmp;
